<template>
  <div>
    <v-card :color="ui.bkgdColor" dark>
      <v-card-text :class="ui.textSubheading"
      v-if="this.getCurrentPage !== null">
        <v-layout row class="ml-4 mt-4"
        v-if="
        this.getCurrentPage !== '/usermanagement' &&
        this.getCurrentPage !== '/companymanagement' &&
        this.getCurrentPage !== '/facilitymanagement'
        ">
          <div v-if="this.getPageInfo !== null">
            <v-icon left :color="ui.btnColor">
              reorder
            </v-icon>
            <span class="title">
              {{defineDocumentFromTag(getPageInfo.tag).title}} Activity Log
            </span>
          </div>
        </v-layout>
        <v-layout row class="mt-1 ml-4"
        v-if="this.getCurrentPage !== '/usermanagement' && this.getPageInfo !== null">
          <div v-if="this.getPageInfo !== null">
            <v-icon left :color="ui.btnColor">
              {{defineDocumentFromTag(getPageInfo.tag).icon}}
            </v-icon>
            {{getPageInfo.title}}
          </div>
        </v-layout>
        <v-layout row>
          <span :class="ui.textSubheading">
            {{info.title}}
          </span>
          <v-spacer/>
          <GetDetailPageDirect
          v-if="enableDocumentLogStatus && this.getPageInfo !== null"
          :data="{
            tag: this.getPageInfo.tag,
            did: this.getPageInfo.did,
            size: 'icon'
            }"
          />
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingError"
          v-if="this.enableNotiLogStatus">
            <v-avatar>
              <v-icon :color="ui.btnColorError">
                notifications_active
              </v-icon>
            </v-avatar>
            {{countItemOnCondition(true, "basic.atn", this.getSearchResults)}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingWarning"
          v-if="this.enableNotiLogStatus">
            <v-avatar>
              <v-icon :color="ui.btnColorWarning">
                mark_email_unread
              </v-icon>
            </v-avatar>
            {{countItemOnCondition(false, "basic.read", this.getSearchResults)}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="!this.enableDocumentLogStatus">
            <v-avatar>
              <v-icon>
                email
              </v-icon>
            </v-avatar>
            {{getSearchResults.length}}
          </v-chip>
          <v-btn :color="ui.bkgdColor" @click="changeSearchResultsSort()" icon>
            <v-icon :color="ui.btnColor"> {{ this.searchResultSortIcon }} </v-icon>
          </v-btn>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          v-if="this.enableDocumentLogStatus">
            <v-avatar>
              <v-icon>playlist_add</v-icon>
            </v-avatar>
            {{getSearchResults.length}}
          </v-chip>
        </v-layout>
      </v-card-text>
      <v-card-text :class="ui.textSubheading"
      v-if="this.getSearchResults !== null">
        <div v-for="item in searchResultsSorted" :key="item.idg">
          <div class="ml-4">
            <v-layout row :class="ui.textSubheadingBold" v-if="enableDocumentLogStatus">
              <v-icon left :color="ui.btnColor">
                {{defineDocumentFromTag(item.char.tag).icon}}
              </v-icon>
              {{item.char.tnoun}} {{displayDocumentIDGTypeA(item.char.tag, item.char.idg)}}
            </v-layout>
            <v-layout row wrap :class="ui.textSubheadingBold" v-else>
              <v-icon left :color="ui.btnColor">
                create
              </v-icon>
              Rev {{displayDocumentRevTypeA(item.rev)}} Doc. {{displayDocumentIDGTypeA(item.basic.tag, item.basic.idg)}}
            </v-layout>
            <v-layout wrap row class="ml-4 mt-2">
              <v-icon left :color="ui.btnColor"> schedule </v-icon>
              <span class="hidden-xs-only">
                {{ dateTypeBWithTimeAgo(item.stats.dcrt) }}
              </span>
              <span class="hidden-sm-and-up">
                {{ dateTimeAgo(item.stats.dcrt) }}
              </span>
            </v-layout>
            <v-layout wrap row class="ml-4 mt-2">
              <v-icon left :color="ui.btnColor"> edit </v-icon>
              {{ item.stats.uname }}
            </v-layout>
            <!-- <v-layout class="ml-3 mt-2">
              <v-chip :color="ui.bkgdColor" :text-color="ui.textColor" :class="ui.textSubheadingBold">
                <v-avatar>
                <v-icon> add </v-icon>
                </v-avatar>
                Activity Description
              </v-chip>
            </v-layout> -->
            <v-layout row wrap class="text-xs-left ml-4 mr-4 mt-2">
              <div :class="ui.textSubheading">
                <span :class="ui.textDescription">
                  {{ genereateDocumentLogChangeText(item.char) }}
                </span>
              </div>
            </v-layout>
            <v-layout wrap row class="ml-4 mt-2"
            v-if="item.rev.modmc !== ''">
              <v-icon left :color="ui.btnColorGrey"> notes </v-icon>
              <div :class="ui.textSubheadingGrey">
                {{item.rev.modmc}}
              </div>
            </v-layout>
            <v-layout wrap row class="ml-4 mt-2"
            v-if="item.rev.modc !== item.rev.modm">
              <v-icon left :color="ui.btnColorGrey"> short_text </v-icon>
              <div :class="ui.textSubheadingGrey">
                {{item.rev.modcc}}
              </div>
            </v-layout>
            <v-layout row class="mb-4">
              <v-spacer/>
              <DocumentLogRead :data="{item: item}" v-if="enableDocumentLogStatus"/>
              <DocumentLogView :data="{item: item}" v-else/>
            </v-layout>
            <v-layout row class="mb-4"/>
          </div>
        </div>
      </v-card-text>
      <v-layout class="mb-4 mr-3" v-if="this.getSearchResults.length > 0">
        <v-spacer/>
        <div v-if="btnSpinLoadMore === false">
          <v-btn
          @click="loadNext()"
          :color="ui.colorBlue"
          flat dark>
            <v-icon left :color="ui.colorBlue"> cloud </v-icon>
              load more
          </v-btn>
        </div>
        <div v-else>
          <BtnSpin dark :btnSpec="btnInfo1"/>
        </div>
      </v-layout>
    </v-card>
</div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import docTagFunctions from "@/document/revisions/mixins/docTagFunctions";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import DocumentLogRead from "@/document/log/components/DocumentLogRead";
import DocumentLogView from "@/document/log/components/DocumentLogView";
import GetDetailPageDirect from "@/support/detail/components/GetDetailPageDirect";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import countFunctions from "@/data/functions/mixins/countFunctions.js";
import revFunctions from "@/data/functions/mixins/revFunctions.js";
import textFunctions from "@/data/functions/mixins/textFunctions.js";
import numberFunctions from "@/data/functions/mixins/numberFunctions.js";
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";

export default {
  components: {
    BtnSpin,
    GetDetailPageDirect,
    // DisplayUserTimeInfo,
    DocumentLogRead,
    DocumentLogView
  },
  mixins: [
    accessFunctions,
    describeDocument,
    dateFunctions,
    apptheme,
    revFunctions,
    countFunctions,
    docTagFunctions,
    displayFunctions,
    numberFunctions,
    textFunctions,
    listFunctions,
    getList
  ],
  methods: {
    changeSearchResultsSort() {
      if (this.getSearchResultsSort === "datecrtAsc") {
        this.$store.dispatch("changeSearchResultsSort", "datecrtDes");
      } else {
        this.$store.dispatch("changeSearchResultsSort", "datecrtAsc");
      }
    }
  },
  data() {
    return {
      valid: true,
      btnSpinLoadMore: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  },
  beforeMount() {
    if (this.getDocumentLogTag === "U1") {
      let list = this.getSearchResults;
      let ctrUnread = this.countItemOnCondition(false, "basic.read", list);
      let ctrAtt = this.countItemOnCondition(false, "basic.att", list);
      this.$store.dispatch("changeDocumentLogUserUnreadCounter", ctrUnread);
      this.$store.dispatch("changeDocumentLogUserAttentionCounter", ctrAtt);
    }
  },
  computed: {
    ...mapGetters([
      "getPageInfo",
      "getPageHeading",
      "getPageSubheading",
      "getSearchResults",
      "getSearchResultsSort",
      "getDetail",
      "getCurrentPage",
      "getDocumentLogTag"
    ]),
    searchResultsSorted() {
      console.log(this.sortListDateCrtAsc(this.getSearchResults)[0].basic.idg);
      // FOR DOCUMENT LOG TAKE ASCEDNING as DEFAULT
      // ASCEDNING MEANS EARLIEST DATE FIRST
      let sort = this.getSearchResults;
      if (this.getSearchResultsSort === "datecrtDes") {
        let temp = this.getSearchResults;
        sort = this.sortListDateCrtDes(temp);
      } else {
        // ASCENDING (EARILEST FIRST)
        let temp = this.getSearchResults;
        sort = this.sortListDateCrtAsc(temp);
      }
      return sort;
    },
    searchResultSortIcon() {
      let icon = null;
      if (this.getSearchResultsSort === "datecrtDes") {
        icon = "south";
      } else {
        icon = "north";
      }
      return icon;
    },
    enableDocumentLogStatus() {
      let logic = null;
      if (this.getPageInfo !== null) {
        // User for User for now
        if (this.getPageInfo.tag === "U1" || this.getPageInfo.tag === "A1") {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }

      return logic;
    },
    enableNotiLogStatus() {
      let logic = null;
      if (this.getPageInfo !== null) {
        // User for User for now
        if (this.getPageInfo.tag === "U1") {
          logic = true;
        } else {
          logic = false;
        }
      } else {
        logic = false;
      }

      return logic;
    },
    info() {
      let obj = {
        heading: "",
        title: "",
        des: ""
      };
      if (this.getDocumentLogTag === "U1") {
        obj.heading = "User Activity Log";
        obj.title = "";
        obj.des = "User activity log items";
      }
      if (this.getDocumentLogTag === "C1") {
        obj.heading = "Company Activity Log";
        obj.title = "";
        obj.des = "Company activity log items";
      }
      if (this.getDocumentLogTag === "F1") {
        obj.heading = "Facility Activity Log";
        obj.title = "";
        obj.des = "Facility activity log items";
      }
      return obj;
    }
    // list() {
    //   return this.getSearchResults;
    // }
  }
};
</script>
